export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10105.bc291b5f.jpg";